import React from "react";
import {
  FormControl,
  Select,
  MenuItem
} from "@material-ui/core";
import styled from "styled-components";

import { maxProceedsOptions } from "../FilterSection/constants";

const StyledMenuItem = styled(MenuItem)`
    &&& {
        font-family: 'Work Sans';
    }
`;

const StyledSelect = styled(Select)`
    font-family: 'Work Sans' !important;
    color: #005AA9 !important;
    div {
        border: none;
    }
`;

const MaxProceedsDropdown = ({ selectedFilter, onChange }) => (
  <FormControl>
    <StyledSelect
      onChange={onChange}
      value={selectedFilter}
    >
      <StyledMenuItem value={1} disabled>Max Proceeds</StyledMenuItem>
      {maxProceedsOptions.map((option, idx) => <StyledMenuItem className="max-proceeds-dropdown-menu-item" key={idx} value={option.value}>{option.label}</StyledMenuItem>)}
    </StyledSelect>
  </FormControl>
);

export default MaxProceedsDropdown;
